import React from 'react';
export function CharacteristicsSection() {
  return <section data-id="element-2328">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-2329">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-2330">
          Characteristics of Mikron's MILL S - High Speed Machining Centers
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 text-center space-y-8" data-id="element-2331">
        <div data-id="element-2332">
          <h3 className="text-3xl font-bold text-[#026ab7] mb-2" data-id="element-2333">
            Mikron MILL S
          </h3>
          <p className="text-xl font-bold text-orange" data-id="element-2334">
            Your Hard Milling Solution - 61 m/min LINEAR DRIVES
          </p>
        </div>

        <div className="max-w-3xl mx-auto text-left grid md:grid-cols-2 gap-8" data-id="element-2335">
          <div className="space-y-6" data-id="element-2336">
            <div data-id="element-2337">
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-2338">
                Swiss Built Step-Tec Spindle
              </h4>
              <ul className="list-disc list-inside text-gray-700 ml-2" data-id="element-2339">
                <li data-id="element-2340">30k to 60k RPM - High RPM</li>
                <li data-id="element-2341">Oil/Air Lubricated - 24/7 Operation</li>
              </ul>
            </div>
            <div data-id="element-2342">
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-2343">
                Linear Drives - Key to faster cycle times!
              </h4>
              <ul className="list-disc list-inside text-gray-700 ml-2" data-id="element-2344">
                <li data-id="element-2345">1.7G Acceleration - 2401 ipm</li>
                <li data-id="element-2346">Highest Accuracy and Cutting Speed</li>
              </ul>
            </div>
            <div data-id="element-2347">
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-2348">
                Polymer Granite Base
              </h4>
              <ul className="list-disc list-inside text-gray-700 ml-2" data-id="element-2349">
                <li data-id="element-2350">
                  Highest level of thermostability and vibration dampening
                </li>
              </ul>
            </div>
          </div>

          <div className="space-y-6" data-id="element-2351">
            <div data-id="element-2352">
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-2353">
                Designed for Productivity & Automation
              </h4>
              <ul className="list-disc list-inside text-gray-700 ml-2" data-id="element-2354">
                <li data-id="element-2355">
                  Ergonomic, No Operator Interference - 24/7 Lights Out
                  Machining
                </li>
              </ul>
            </div>
            <div data-id="element-2356">
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-2357">
                Heidenhain CNC
              </h4>
              <ul className="list-disc list-inside text-gray-700 ml-2" data-id="element-2358">
                <li data-id="element-2359">Best in Class for 5-Axis, Contouring, Fully Loaded</li>
              </ul>
            </div>
            <div data-id="element-2360">
              <h4 className="font-bold text-lg text-orange" data-id="element-2361">
                Easily Equipped for Graphite or Hard Milling
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>;
}